import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "gatsby";
import PropTypes from "prop-types";

import RichTextBlock from "./RichTextBlock";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import PillsTop from "../images/icons/Pills-top.svg";
import PillsBottom from "../images/icons/Pills-bottom.svg";

import "../styles/components/FormSuccessResult.scss";

const FormSuccessResult = ({ successMessage, children, submittedFormLink }) => {
    let buttonProps = {};

    if (submittedFormLink.downloadAsset) {
        buttonProps.as = "a";
        buttonProps.href = submittedFormLink.downloadAsset.url;
        buttonProps.target = "_blank";
    } else {
        buttonProps.as = Link;
        buttonProps.to = submittedFormLink.url;
    }

    return (
        <div className="form-success-result">
            <PillsTop className="pills top-pills" />
            <RichTextBlock content={successMessage} />
            {buttonProps.as && (
                <Button {...buttonProps}>
                    {submittedFormLink.icon && (
                        <GatsbyImageWithSVGSupport
                            className="me-3"
                            image={submittedFormLink.icon}
                        />
                    )}
                    {submittedFormLink.label}
                </Button>
            )}
            <PillsBottom className="pills botttom-pills" />
            {children}
        </div>
    );
};

FormSuccessResult.propTypes = {
    children: PropTypes.node,
    successMessage: PropTypes.shape({
        raw: PropTypes.string,
        references: PropTypes.array,
    }),
    submittedFormLink: PropTypes.shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string,
        icon: PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string,
            gatsbyImageData: PropTypes.object,
            file: PropTypes.shape({
                contentType: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            }),
        }),
        downloadAsset: PropTypes.shape({
            filename: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }),
};

export default FormSuccessResult;
